/* Presura storefront behaviour. No dependencies. */
(function () {
  'use strict';

  /* ---------- money ----------
     Mirrors Liquid's `| money` filter so JS-rendered prices match the
     server-rendered ones exactly. Format comes from the shop (emitted in
     theme.liquid); falls back to the active presentment currency. */
  var MONEY_FORMAT = (window.PresuraShop && window.PresuraShop.moneyFormat) || '';

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents == null) return '0';
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';
    var parts = (cents / 100.0).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  var money = function (cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents);

    if (!MONEY_FORMAT) {
      var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GHS';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100);
      } catch (e) {
        return code + ' ' + (cents / 100).toFixed(2);
      }
    }

    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = MONEY_FORMAT.match(placeholder);
    if (!match) return MONEY_FORMAT;

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':                      value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator':             value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator':             value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator':        value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default:                                        value = formatWithDelimiters(cents, 2);
    }
    /* This shop's format wraps the amount in <span class=money> for the
       currency-converter app. Every caller writes the result with
       textContent, so strip the markup or the tags print on the button. */
    return MONEY_FORMAT.replace(placeholder, value).replace(/<[^>]*>/g, '');
  };

  /* ---------- cart drawer ---------- */
  var drawer = document.querySelector('[data-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]') || e.target.hasAttribute('data-drawer-scrim')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    var sheet = document.querySelector('[data-sheet].is-open');
    if (sheet) sheet.classList.remove('is-open');
  });
  /* focus trap */
  if (drawer) drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    var f = drawer.querySelectorAll('a[href],button:not([disabled]),input,select,textarea');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function refreshDrawer() {
    fetch('/?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-drawer-inner]');
        var target = drawer && drawer.querySelector('[data-drawer-inner]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
        });
      });
  }

  /* ---------- add to cart (quick-add + PDP) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.innerHTML = 'Adding…'; }

    /* "Pairs perfectly with": while its box is ticked, the main product and
       the pair go up in ONE JSON request, so the error slot, the drawer
       refresh and the drawer open below treat the pair exactly like the main
       line. The sticky bar submits this same form, so it takes this path too.
       Any other form — quick-add, the drawer upsell — is the plain FormData
       post it always was. */
    var pairCheck = form.querySelector('[data-pair-check]');
    var withPair = !!(pairCheck && pairCheck.checked);
    var request;
    if (withPair) {
      var pair = pairState();
      var idEl = form.querySelector('[name=id]');
      var main = { id: Number(idEl ? idEl.value : 0), quantity: 1, properties: {} };
      new FormData(form).forEach(function (val, key) {
        if (key === 'quantity') main.quantity = Math.max(1, parseInt(val, 10) || 1);
        var prop = /^properties\[(.+)\]$/.exec(key);
        if (prop) main.properties[prop[1]] = val;
      });
      if (!Object.keys(main.properties).length) delete main.properties;
      request = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [main, { id: Number(pair.id), quantity: 1 }] })
      });
    } else {
      request = fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
    }

    var added = false;
    request
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        var slot = form.querySelector('[data-atc-error]');
        if (!res.ok) {
          var msg = (res.body && (res.body.description || res.body.message)) || 'Sorry, that could not be added to your bag.';
          if (slot) { slot.textContent = msg; slot.hidden = false; }
          return;
        }
        if (slot) { slot.textContent = ''; slot.hidden = true; }
        added = true;
        refreshDrawer();
        openDrawer();
      })
      /* Network failure: fall back to a native submit. That carries the main
         line only, which beats a dead button. */
      .catch(function () { form.submit(); })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = label; }
        /* The pair is in the bag now; left ticked, a second tap would add it
           again. Untick it after the label is back so the reset lands on the
           restored <span data-atc-label>. */
        if (added && withPair && pairCheck.checked) {
          pairCheck.checked = false;
          pairCheck.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
  });

  /* ---------- cart line quantity / remove ---------- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-line-change]');
    if (!el) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(el.dataset.line), quantity: Number(el.dataset.lineChange) })
    }).then(refreshDrawer);
  });

  /* ---------- cart line quantity typed directly ----------
     The cart inputs used to be `readonly`, so a shopper could only step one at a
     time and never type a quantity. */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-set]');
    if (!input) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(input.dataset.lineSet), quantity: qty })
    }).then(refreshDrawer);
  });

  /* ---------- quantity stepper ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty="up"],[data-qty="down"]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (b.dataset.qty === 'up' ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- variant picker ----------
     Resolves a variant from the full option selection. Two fixes over the old
     swatch handler: it handles every option (not just colour), and it writes the
     chosen id into the add-to-cart form. The picker renders OUTSIDE that form, so
     the old `root.querySelector('[name=id]')` matched nothing and the shop
     silently added the default variant no matter what the shopper clicked. */
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var blob = root.querySelector('[data-variant-json]');
    var data = [];
    try { data = JSON.parse(blob ? blob.textContent : '[]') || []; } catch (err) { data = []; }
    if (!data.length) return;

    var rows = root.querySelectorAll('[data-opt-pos]');

    function selection() {
      return Array.prototype.map.call(rows, function (row) {
        var on = row.querySelector('[aria-pressed="true"]');
        return on ? on.getAttribute('data-opt-value') : null;
      });
    }

    function match(sel) {
      for (var i = 0; i < data.length; i++) {
        var v = data[i], ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && String(v.options[j]) !== String(sel[j])) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function apply(v) {
      var idInput = document.querySelector('#AddToCart [name=id]') ||
                    document.querySelector('form[action*="/cart/add"] [name=id]');
      if (idInput) {
        idInput.value = v.id;
        idInput.setAttribute('data-price', v.price); /* cents; the pair total reads this */
      }

      document.querySelectorAll('[data-variant-name]').forEach(function (el) { el.textContent = v.title; });
      document.querySelectorAll('[data-variant-price]').forEach(function (el) { el.textContent = money(v.price); });

      /* Back to the image — tearing down any video that is playing — then
         point it at the variant's own shot and mark the matching thumb. */
      var shot = v.featured_image ? v.featured_image.src : null;
      /* A variant with no image of its own, picked while a video is showing,
         falls back to the first still: otherwise the frame would show whatever
         image was up before the video while a different thumb is marked. */
      var videoWasCurrent = gallery && gallery.querySelector('[data-thumb-video][aria-current="true"]');
      var firstStill = (!shot && videoWasCurrent) ? gallery.querySelector('[data-thumb]') : null;
      galleryShowImage(shot || (firstStill ? firstStill.getAttribute('data-thumb') : null));
      var thumb = galleryMatchThumb(shot) || firstStill;
      if (thumb) galleryMark(thumb);

      /* The quantity tiers are server-rendered from the variant the page loaded
         with. Without this they keep quoting the old variant's price after a
         switch — e.g. a GH₵369 plug still showing GH₵419 / 838 / 1257. */
      document.querySelectorAll('[data-tiers] input[data-qty]').forEach(function (tier) {
        var q = parseInt(tier.getAttribute('data-qty'), 10) || 1;
        var total = money(v.price * q);
        tier.setAttribute('data-total', total);
        var row = tier.closest('.tier');
        if (!row) return;
        var cell = row.querySelector('[data-tier-total]');
        if (cell) cell.textContent = total;
        var each = row.querySelector('[data-tier-each]');
        if (each) each.textContent = money(v.price) + ' each';
      });

      var atc = document.querySelector('[data-atc-label]');
      if (atc) {
        var picked = document.querySelector('[data-tiers] input:checked');
        if (!v.available) {
          atc.textContent = 'Sold out';
        } else if (picked && Number(picked.getAttribute('data-qty')) > 1) {
          atc.textContent = 'Add to bag — ' + picked.getAttribute('data-total');
        } else {
          atc.textContent = 'Add to bag';
        }
      }
      document.querySelectorAll('#AddToCart [type=submit],[form="AddToCart"]').forEach(function (b) {
        b.disabled = !v.available;
      });

      var err = document.querySelector('[data-atc-error]');
      if (err) { err.textContent = ''; err.hidden = true; }

      /* With the pair ticked, the label quotes the combined total instead. */
      syncAtcLabel(false);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-opt-value]');
      if (!btn) return;
      e.preventDefault();
      var row = btn.closest('[data-opt-pos]');
      if (!row) return;

      row.querySelectorAll('[data-opt-value]').forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (!b.classList.contains('swatch')) {
          b.style.background = on ? 'var(--surface)' : 'transparent';
          b.style.borderColor = on ? 'var(--ink)' : 'var(--line-soft)';
        }
      });
      var label = row.querySelector('[data-opt-label]');
      if (label) label.textContent = btn.getAttribute('data-opt-value');

      var v = match(selection());
      if (v) apply(v);
    });
  });

  /* ---------- bundle tiers ---------- */
  document.querySelectorAll('[data-tiers]').forEach(function (root) {
    root.addEventListener('change', function () {
      var on = root.querySelector('input:checked');
      if (!on) return;
      root.querySelectorAll('.tier').forEach(function (t) { t.classList.toggle('tier--on', t.contains(on)); });
      var qty = document.querySelector('[data-main-qty]');
      if (qty) { qty.value = on.dataset.qty; qty.dispatchEvent(new Event('change', { bubbles: true })); }
      var atc = document.querySelector('[data-atc-label]');
      if (atc && on.dataset.total) atc.textContent = 'Add to bag — ' + on.dataset.total;
    });
  });

  /* ---------- gallery: thumbs + video ----------
     The main <img> is the LCP element and stays in the DOM for the life of the
     page. A video thumb clones its inert <template> into a stage laid over the
     frame and hides the image behind it; an image thumb or a variant change
     tears the stage down again, which pauses a <video> and unloads an
     <iframe>. Nothing here runs on load, so a page with video downloads
     exactly what a page without one does. */
  var gallery = document.querySelector('[data-gallery]');
  var galleryMain = gallery ? gallery.querySelector('[data-gallery-main]') : null;
  var galleryImg = galleryMain ? galleryMain.querySelector('img') : null;
  var galleryStage = null;

  function galleryMark(el) {
    if (!gallery) return;
    gallery.querySelectorAll('[data-thumb],[data-thumb-video]').forEach(function (x) {
      x.setAttribute('aria-current', x === el ? 'true' : 'false');
    });
  }
  /* The variant JSON gives an absolute CDN url with no size; data-thumb holds a
     protocol-relative one with ?width=. Compare the path only. */
  function galleryMatchThumb(src) {
    if (!gallery || !src) return null;
    var norm = function (u) { return String(u).split('?')[0].replace(/^https?:/, ''); };
    var want = norm(src), hit = null;
    gallery.querySelectorAll('[data-thumb]').forEach(function (x) {
      if (!hit && norm(x.getAttribute('data-thumb')) === want) hit = x;
    });
    return hit;
  }
  function galleryClear() {
    if (!galleryStage) return;
    var vid = galleryStage.querySelector('video');
    if (vid) { try { vid.pause(); } catch (err) { /* never had a source */ } }
    galleryStage.remove();
    galleryStage = null;
    galleryMain.classList.remove('is-video');
  }
  function galleryShowImage(src) {
    galleryClear();
    if (galleryImg && src) { galleryImg.src = src; galleryImg.srcset = ''; }
  }
  function galleryShowVideo(id) {
    var tpl = gallery ? gallery.querySelector('template[data-video-template="' + id + '"]') : null;
    if (!tpl || !galleryMain) return;
    galleryClear();
    var stage = document.createElement('div');
    stage.className = 'pdp__stage';
    stage.appendChild(tpl.content.cloneNode(true));
    galleryMain.appendChild(stage);
    galleryMain.classList.add('is-video');
    galleryStage = stage;
    /* The tap that got us here is the user gesture, so start playback now
       instead of asking for a second tap on the player. */
    var vid = stage.querySelector('video');
    if (vid) { var playing = vid.play(); if (playing && playing.catch) playing.catch(function () {}); }
  }

  if (gallery) gallery.addEventListener('click', function (e) {
    /* External video: the poster is a plain <img> until this press, so the
       player script is only fetched by someone who asked for it. */
    var ext = e.target.closest('[data-ext-src]');
    if (ext) {
      var frame = document.createElement('iframe');
      frame.className = 'pdp__ext-frame';
      frame.src = ext.getAttribute('data-ext-src');
      frame.title = ext.getAttribute('aria-label') || 'Product video';
      frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      frame.setAttribute('allowfullscreen', '');
      ext.replaceWith(frame);
      return;
    }
    var t = e.target.closest('[data-thumb],[data-thumb-video]');
    if (!t) return;
    if (t.hasAttribute('data-thumb-video')) galleryShowVideo(t.getAttribute('data-thumb-video'));
    else galleryShowImage(t.getAttribute('data-thumb'));
    galleryMark(t);
  });

  /* ---------- "Pairs perfectly with" ----------
     One checkbox adds a second product in the same request as the main one
     (see the submit handler). While it is ticked the Add-to-bag label quotes
     the combined total — (variant price × quantity) + pair price — and is
     recomputed on every variant, tier, quantity or pair-variant change.
     Unticked it is a no-op: the tier and variant handlers' own labels stand. */
  var pairMod = document.querySelector('[data-pair]');
  var atcForm = document.getElementById('AddToCart');

  function pairState() {
    if (!pairMod) return null;
    var check = pairMod.querySelector('[data-pair-check]');
    var sel = pairMod.querySelector('[data-pair-select]');
    var id = pairMod.getAttribute('data-pair-variant');
    var price = Number(pairMod.getAttribute('data-pair-price')) || 0;
    if (sel && sel.selectedIndex > -1) {
      var opt = sel.options[sel.selectedIndex];
      id = opt.value;
      price = Number(opt.getAttribute('data-price')) || 0;
    }
    return { on: !!(check && check.checked), id: id, price: price };
  }

  function syncAtcLabel(restore) {
    var atc = document.querySelector('[data-atc-label]');
    var pair = pairState();
    if (!atc || !pair) return;
    var btn = atc.closest('button');
    if (btn && btn.disabled) return; /* 'Sold out' stands */
    if (pair.on) {
      var idInput = document.querySelector('#AddToCart [name=id]');
      var unit = idInput ? Number(idInput.getAttribute('data-price')) || 0 : 0;
      var qtyEl = document.querySelector('[data-main-qty]');
      var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
      atc.textContent = 'Add to bag — ' + money(unit * qty + pair.price);
    } else if (restore) {
      /* Just unticked: back to what the variant handler would show. */
      var picked = document.querySelector('[data-tiers] input:checked');
      if (picked && Number(picked.getAttribute('data-qty')) > 1 && picked.getAttribute('data-total')) {
        atc.textContent = 'Add to bag — ' + picked.getAttribute('data-total');
      } else {
        atc.textContent = 'Add to bag';
      }
    }
  }

  function applyPairCheck(on) {
    pairMod.classList.toggle('is-on', on);
    /* Express checkout carries one line only, so it steps aside while the
       pair is ticked rather than silently dropping it at checkout. */
    var express = atcForm ? atcForm.querySelector('[data-dynamic-checkout]') : null;
    if (express) express.hidden = on;
  }

  if (pairMod) {
    document.addEventListener('change', function (e) {
      var inForm = atcForm && atcForm.contains(e.target);
      if (!inForm && !pairMod.contains(e.target)) return;
      if (e.target.matches('[data-pair-select]')) {
        var st = pairState();
        pairMod.setAttribute('data-pair-variant', st.id);
        pairMod.setAttribute('data-pair-price', st.price);
        var lbl = pairMod.querySelector('[data-pair-price-label]');
        if (lbl) lbl.textContent = money(st.price);
      }
      if (e.target.matches('[data-pair-check]')) {
        applyPairCheck(e.target.checked);
        syncAtcLabel(true);
        return;
      }
      syncAtcLabel(false);
    });
    /* Browsers may restore a ticked box on back-navigation. */
    var initial = pairState();
    if (initial.on) { applyPairCheck(true); syncAtcLabel(false); }
  }

  /* ---------- sticky ATC ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var anchor = document.querySelector('[data-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- filter sheet + mobile nav ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sheet-open]')) {
      e.preventDefault();
      var s = document.querySelector('[data-sheet]');
      if (s) s.classList.add('is-open');
    }
    if (e.target.closest('[data-sheet-close]') || e.target.hasAttribute('data-sheet-scrim')) {
      var s2 = document.querySelector('[data-sheet]');
      if (s2) s2.classList.remove('is-open');
    }
    var burger = e.target.closest('[data-nav-toggle]');
    if (burger) {
      var nav = document.querySelector('[data-mob-nav]');
      if (nav) {
        var open = nav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });
})();
